<template>
  <form>
    <md-card>
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">Profile Permissions - <small>Update</small></h4>
      </md-card-header>
      <md-card-content class="md-size-50 mx-auto" v-if="table_spinner">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </md-card-content>
      <md-card-content style="max-height: 700px; overflow: auto; text-align: center">
        <div v-for="p in group_permissions" v-bind:key="p">
          <h4 class="card-title" v-if="p.permissions.length">{{ p.Label }}</h4>
          <div class="md-layout" v-for="per in p.permissions" v-bind:key="per.id">
            <label class="md-layout-item md-size-60 md-form-label">
              {{ per.name }}
            </label>
            <div class="md-layout-item md-size-40">
              <md-switch
                @change="updatePermission(per.codename, per.has_perm)"
                v-model="per.has_perm"
                :name="per.codename"
              ></md-switch>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
export default {
  name: "edit-profile-form",
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      userID: null,
      role: null,
      group_permissions: {
        admin_user: {permissions: [], Label:"Admin User Permissions", expect_permissions: ["view_admin_user", "add_admin_user", "change_admin_user", "delete_admin_user", "change_admin_user_perm", "apply_university_perm"]},
        student_user:{permissions: [], Label:"Student User Permissions", expect_permissions: ["view_student_user","add_student_user", "change_student_user", "delete_student_user"]},
        agency_user: {permissions: [], Label:"Agency User Permissions", expect_permissions: ["view_agency_user", "change_agency_user", "add_agency_user", "delete_agency_user", "change_agency_user_perm", "view_agency_student_user", "add_agency_student_user", "change_agency_student_user", "delete_agency_student_user"]},
        university_user: {permissions: [], Label:"University User Permissions", expect_permissions: ["view_uni_user", "change_uni_user", "add_uni_user", "delete_uni_user", "change_uni_user_perm", "view_uni_student_user", "change_uni_student_user", "add_uni_student_user", "delete_uni_student_user"]},
        dorm_user: {permissions: [], Label:"Dorm User Permissions", expect_permissions: ["view_dorm_user", "change_dorm_user", "add_dorm_user", "delete_dorm_user", "change_dorm_user_perm", "view_dorm_student_user", "change_dorm_student_user", "add_dorm_student_user", "delete_dorm_student_user"]},
        program: {permissions: [], Label:"Program Permissions", expect_permissions: ["add_program", "change_program", "delete_program"]},
        university: {permissions: [], Label:"University Permissions", expect_permissions: ["add_university", "change_university", "delete_university"]},
        agency: {permissions: [], Label:"Agency Permissions", expect_permissions: ["view_agency", "add_agency", "change_agency", "delete_agency"]},
        dorm: {permissions: [], Label:"Dorm Permissions", expect_permissions: ["view_dorm", "add_dorm", "change_dorm", "delete_dorm"]},
        application: {permissions: [], Label:"Application Permissions", expect_permissions: ["view_application", "add_application", "change_application", "delete_application"]},
        agency_application: {permissions: [], Label:"Agency Application Permissions", expect_permissions: ["view_agency_application", "add_agency_application", "change_agency_application", "delete_agency_application"]},
        uni_application: {permissions: [], Label:"University Application Permissions", expect_permissions: ["view_uni_application", "add_uni_application", "change_uni_application", "delete_uni_application"]},
        dorm_application: {permissions: [], Label:"Dorm Application Permissions", expect_permissions: ["view_dorm_application", "add_dorm_application", "change_dorm_application", "delete_dorm_application"]},
        agency_commission: {permissions: [], Label:"Agency Commission Permissions", expect_permissions: ["view_agency_commission"]},
        commission: {permissions: [], Label:"Commission Permissions", expect_permissions: ["view_commission", "add_commission", "change_commission", "delete_commission"]},
        insurances: {permissions: [], Label:"Insurances Permissions", expect_permissions: ["view_agency_insurances", "add_agency_insurances", "change_agency_insurances", "delete_agency_insurances"]},
        season: {permissions: [], Label:"Season Permissions", expect_permissions: ["add_season", "change_season", "delete_season"]},
        candidate_form: {permissions: [], Label:"Candidate Form Permissions", expect_permissions: ["view_candidateform", "add_candidateform", "change_candidateform", "delete_candidateform"]},
        city: {permissions: [], Label:"City Permissions", expect_permissions: ["add_city", "change_city", "delete_city"]},
        country: {permissions: [], Label:"Country Permissions", expect_permissions: ["add_country", "change_country", "delete_country"]},
        transportation: {permissions: [], Label:"Transportation Permissions", expect_permissions: ["add_transportation", "change_transportation", "delete_transportation"]},
        place: {permissions: [], Label:"Place Permissions", expect_permissions: ["add_place", "change_place", "delete_place"]},
        faq: {permissions: [], Label:"FAQ Permissions", expect_permissions: ["add_faq", "change_faq", "delete_faq", "view_faq"]},
        article: {permissions: [], Label:"Article Permissions", expect_permissions: ["add_article", "change_article", "delete_article", "view_article"]},
      },
      permissions: [],
      table_spinner: true
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    updatePermission(codename, has_perm) {
      if (has_perm) {
        this.$store
          .addUserPermissions(this.role, this.userID, codename)
          .then(response => {
            this.$notify({
              message: "Permission added.",
              icon: "add_alert",
              type: "success",
              verticalAlign: "top"
            });
          })
          .catch(error => {
            this.$notify({
              message: error.response.data,
              icon: "add_alert",
              type: "warning",
              verticalAlign: "top"
            });
          });
      } else {
        this.$store
          .removeUserPermissions(this.role, this.userID, codename)
          .then(response => {
            this.$notify({
              message: "Permission removed.",
              icon: "add_alert",
              type: "success",
              verticalAlign: "top"
            });
          })
          .catch(error => {
            this.$notify({
              message: error.response.data,
              icon: "add_alert",
              type: "warning",
              verticalAlign: "top"
            });
          });
      }
    },
    groupPermission(permissions) {
      for (const permission_key in permissions) {
        for (const group_permission_key in this.group_permissions) {
          if (this.group_permissions[group_permission_key].expect_permissions.indexOf(permissions[permission_key].codename) !== -1) {
            this.group_permissions[group_permission_key].permissions.push(permissions[permission_key])
          }
        }
      }
    }
  },
  mounted() {
    if (this.$route.meta.staff === "admin") {
      this.role = 1;
    } else if (this.$route.meta.staff === "agency") {
      this.role = 3;
    } else if (this.$route.meta.staff === "university") {
      this.role = 4;
    } else if (this.$route.meta.staff === "dorm") {
      this.role = 5;
    }

    this.userID = this.$route.params.id;
    this.$store
      .getUserPermissions(this.role, this.userID)
      .then(response => {
        this.permissions = response.data;
        this.groupPermission(this.permissions)
        this.table_spinner = false;
      })
      .catch(error => {
        this.table_spinner = false;
        this.$notify({
          message: error.message,
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
      });
  }
};
</script>
<style></style>
